import {getSurveysTemplates, getSurveyById, createCopySurvey, getSurveysByReportId, removeSurvey, updateSurveyCopy, updateReportSurvey} from '../api/survey';

import {getErrors} from '../utils/tools';

export function getSurveysByReportIdAction(report_id) {
    return(dispatch)=>{
        return this.loggedIn().then((res) => { // Vérifie l'authentification
            const token = localStorage.getItem("id_token")
            return getSurveysByReportId(token, report_id)
                .then(res => {
                    return res;
                })
                .catch((err)=>{
                    let errors = getErrors(err)
                    this.displaySnackbar("error", errors[0].message);
                    throw err
                })
        })
    }
}
export function getSurveysTemplatesAction() {
    return(dispatch)=>{
        return this.loggedIn().then((res) => { // Vérifie l'authentification
            const token = localStorage.getItem("id_token")
            return getSurveysTemplates(token)
                .then(res => {
                    dispatch({
                        type:"UPDATE_SURVEYS_TEMPLATES",
                        surveysTemplates:res
                    });
                    return res;
                })
                .catch((err)=>{
                    let errors = getErrors(err)
                    this.displaySnackbar("error", errors[0].message);
                    throw err
                })
        })
    }
}
export function getSurveyByIdAction(id) {
    return(dispatch)=>{
        return this.loggedIn().then((res) => { // Vérifie l'authentification
            const token = localStorage.getItem("id_token")
            return getSurveyById(token, id)
                .then(res => {
                    return res;
                })
                .catch((err)=>{
                    let errors = getErrors(err)
                    this.displaySnackbar("error", errors[0].message);
                    throw err
                })
        })
    }
}

/*
  Créer un nouveau formulaire à partir d'un template
*/
export function createCopySurveyAction(survey_id, report_id, data) {
    return(dispatch)=>{
        return this.loggedIn().then((res) => { // Vérifie l'authentification
            const token = localStorage.getItem("id_token")
            return createCopySurvey(token, survey_id, report_id, data)
                .then(res => {
                    this.displaySnackbar("success", "Formulaire enregistré");
                    dispatch({
                        type:"ADD_SURVEY_TO_REPORT",
                        survey:res,
                        report_id: report_id
                    });
                    return res
                })
                .catch((err)=>{
                    let errors = getErrors(err)
                    this.displaySnackbar("error", errors[0].message);
                    throw err
                })
        })
    }
}

/*
  Met à jour un formulaire
*/
export function updateSurveyCopyAction(survey_id, report_id, data) {
    return(dispatch)=>{
        return this.loggedIn().then((res) => { // Vérifie l'authentification
            const token = localStorage.getItem("id_token")
            return updateSurveyCopy(token, survey_id, report_id, data)
                .then(res => {
                    this.displaySnackbar("success", "Formulaire mis à jour");
                    dispatch({
                        type:"UPDATE_SURVEY_TO_REPORT",
                        survey:res,
                        report_id: report_id
                    });
                    return res
                })
                .catch((err)=>{
                    let errors = getErrors(err)
                    this.displaySnackbar("error", errors[0].message);
                    throw err
                })
        })
    }
}

/*
  Supprimer un formulaire
*/
export function removeSurveyAction(id) {
    return(dispatch)=>{
        return this.loggedIn().then((res) => { // Vérifie l'authentification
            const token = localStorage.getItem("id_token")
            return removeSurvey(token, id)
                .then(res => {
                    this.displaySnackbar("success", "Formulaire supprimé");
                    return res
                })
                .catch((err)=>{
                    let errors = getErrors(err)
                    this.displaySnackbar("error", errors[0].message);
                    throw err
                })
        })
    }
}

/*
  Met à jour un formulaire
*/
export function updateReportSurveyAction(report, id, survey, data) {
    return(dispatch)=>{
        dispatch({
            type:"UPDATE_SURVEY",
            report: report,
            survey:survey
        });
        return this.loggedIn().then((res) => { // Vérifie l'authentification
            const token = localStorage.getItem("id_token")
            return updateReportSurvey(token, id, data)
                .then(res => {

                    this.displaySnackbar("success", "Formulaire modifié");
                    return res
                })
                .catch((err)=>{
                    let errors = getErrors(err)
                    this.displaySnackbar("error", errors[0].message);
                    throw err
                })
        })
    }
}


// WEBPACK FOOTER //
// ./src/actions/survey.js